import React from 'react'

const LocationIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" fill="none" viewBox="0 0 18 21">
		<path
			className="stroke-current"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M14.657 14.657L10.414 18.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
		></path>
		<path
			className="stroke-current"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M12 9a3 3 0 11-6 0 3 3 0 016 0z"
		></path>
	</svg>
)

export default LocationIcon
